import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";
import Chatbot from "@/components/marketing/Chatbot";
import { metadataForPath } from "@/lib/metadata";

export default function MarketingLayout() {
  const lenisRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    const onMenu = (event) => event.detail ? lenis.stop() : lenis.start();
    window.addEventListener("ranger-menu", onMenu);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("ranger-menu", onMenu);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    const [title, description] = metadataForPath(pathname);
    document.title = title;
    const descriptionTag = document.querySelector('meta[name="description"]');
    descriptionTag?.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://ranger.rclintegrated.com${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);

  return (
    <div className="bg-rc-bg min-h-screen">
      <Navbar />
      <Outlet />
      <Footer />
      <Chatbot />
    </div>
  );
}
